import { Shortcut, SidebarTitle } from "components/Layout";
import { Section } from "components/content/Section";
import { IDraggableAlignmentResultSection, ISectionGroup, SectionGroup } from "store/types";
import unsorted from "../../components/content/icons/unsorted.svg";
import { DraggableLocation } from "@hello-pangea/dnd";
import { EmptyGroupPlaceholder } from "./EmptyGroupPlaceholder";
import { isEmpty } from "lodash";
import DoneIcon from "@mui/icons-material/Done";
import { Grid } from "@mui/material";

interface IProps {
  state: any;
  onMoveResourceViaMenu: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
  onExcludeResourceViaMenu: (source: DraggableLocation, draggableId: string[]) => any;
}

export const Unsorted = ({ state, onMoveResourceViaMenu, onExcludeResourceViaMenu }: IProps) => {
  const sectionGroup =
    state &&
    state.sectionGroups &&
    state.sectionGroups.find((sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.UNSORTED);
  if (sectionGroup) {
    return (
      <div
        style={{
          border: "2px solid #FB9701",
          backgroundColor: "white",
          padding: 16,
          margin: 16,
        }}
      >
        <Grid container spacing={0}>
          <Grid item xs={1} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <img style={{ height: "20px" }} src={unsorted} alt="" title="Unsorted" />
          </Grid>
          <Grid item xs={9} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <SidebarTitle>Unsorted</SidebarTitle>
          </Grid>
          <Grid item xs={2} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
            <Shortcut>U</Shortcut>
          </Grid>
        </Grid>
        &nbsp;
        {isEmpty(sectionGroup.sections) && (
          <EmptyGroupPlaceholder
            color="#DFF9D2"
            borderColor="#398712"
            text="All content has been mapped."
            icon={<DoneIcon />}
          />
        )}
        {sectionGroup.sections.map((section: IDraggableAlignmentResultSection, index: number) => {
          const resources = section.resourceIds.map((uid: any) =>
            state.resources.find((resource: any) => resource.uid === uid),
          );
          return (
            <Section
              key={section.uid}
              state={state}
              section={section}
              resources={resources}
              onMoveResourceViaMenu={onMoveResourceViaMenu}
              onExcludeResourceViaMenu={onExcludeResourceViaMenu}
              expand={false}
              sidebar={true}
              shortcut={index === 0 ? ["u", "U"] : undefined}
            />
          );
        })}
      </div>
    );
  } else {
    return null;
  }
};
